import validate from 'jquery-validation';
import translations from '../../../lang/translations';
import { setupSelectCountryStateCity } from './form/form-stara';
validate;

/*$.validator.methods.email = function (value, element) {
    return this.optional(element) || /[a-z]+@[a-z]+\.[a-z]+/.test(value);
};*/

function setupBudgetForm() {
    $('.budget-form').validate({
        onFocusOut: true,
        errorClass: 'input-error',
        errorElement: 'span',
        errorLabelContainer: '.budget-form .errors',
        rules: {
            first_name: 'required',
            last_name: 'required',
            email: {
                required: true,
                email: true,
            },
            company: 'required',
            phone: {
                required: true,
                minlength: 8,
            },
            country_id: { number: true, required: true },
            city_id: 'number',
            state_id: 'number',
            product_id: { number: true, required: true },
            message: 'required',
            privacy: 'required',
        },
        messages: translations[window.currentLocale()],
        invalidHandler: function () {
            $('.budget-form .btn-submit').removeClass('loading');
            $('.budget-form .success').empty();
            reloadCaptcha('contact');
        },
        submitHandler: function (form, event) {
            if ($('.budget-form .btn-submit').hasClass('loading')) {
                return;
            }

            $('.budget-form .btn-submit').addClass('loading');
            event.preventDefault();
            event.stopPropagation();

            setTimeout(function () {
                $('.budget-form .btn-submit').removeClass('loading');
            }, 1000);

            $.ajax({
                type: 'POST',
                url: $(form).data('action'),
                data: $(form).serialize(),
                success: function (data) {
                    form.reset();
                    $('.budget-form .success').html(data);
                },
                error: function (data) {
                    console.log(data.responseJSON);
                    $('.budget-form .success').empty();

                    $('.budget-form .errors')
                        .html(Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>'))
                        .show({ duration: 0 });

                    try {
                        reloadCaptcha('contact');
                    } catch (e) {
                        console.log(e);
                    }
                },
            });
        },
    });
}

function initialize() {
    setupBudgetForm();
    setupSelectCountryStateCity($('.budget-form'));
}

initialize();
